module.exports = __webpack_public_path__ + "img/bg44.1dd0c750.png";